import ContentsEditorLogo from '~assets/graphics/graphic-logo.png';
import useViewTransition from '~hooks/useViewTransition';

const Sidebar = () => {
  const { navigateWithTransition } = useViewTransition();

  const handleCreateNew = () => {
    navigateWithTransition('/edit');
  };

  return (
    <aside className="flex w-[268px] flex-col justify-start gap-6 rounded-xl bg-white p-4">
      {/* 로고 */}
      <div className="w-[236px] h-[184px] flex items-center justify-center bg-CoolGray-10">
        <img src={ContentsEditorLogo} alt="logo" width={141} height={48} />
      </div>

      {/* 새로운 콘텐츠 작성 버튼 */}
      <button
        onClick={handleCreateNew}
        className="flex items-center justify-center gap-2 rounded-md bg-[#FFED49] px-4 py-2 shadow-sm transition-all hover:bg-[#FFE91F]"
      >
        <svg
          className="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 4v16m8-8H4"
          />
        </svg>
        <span className="text-sm font-bold leading-[18px] text-[#2C3744]">
          새로운 콘텐츠 작성하기
        </span>
      </button>
    </aside>
  );
};

export default Sidebar;
